import { Cell, Pie, PieChart } from 'recharts'

const ProgressMissionMonitoring = ({ data }: any) => {
    const COLORS = ["#fdc700", "#FB2C36", "#50A2FF", "#05DF72"];
    const GREY = "#d3d3d3";
    const renderLabel = ({
        cx,
        cy,
        midAngle,
        outerRadius,
        count,
      }: {
        cx: number;
        cy: number;
        midAngle?: number;
        innerRadius?: number;
        outerRadius: number;
        // Champ personnalisé injecté via les données du Pie, absent des types recharts
        count?: number;
      }) => {
        if (count === 0 || count === null || count === undefined || isNaN(count)) {
          return null;
        }
        // Positionner les labels à l'extérieur du pie chart
        const angle = midAngle ?? 0;
        const radius = outerRadius + 20; // 20px au-delà du rayon extérieur
        const x = cx + radius * Math.cos(-angle * (Math.PI / 180));
        const y = cy + radius * Math.sin(-angle * (Math.PI / 180));
      
        return (
          <text
            x={x}
            y={y}
            fill="black"
            textAnchor={x > cx ? "start" : "end"}
            dominantBaseline="central"
            fontSize="12"
          >
            {`${count}`}
          </text>
        );
      };

      const renderLabelLine = ({
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        percent,
        index,
        count,
      }: {
        cx: number;
        cy: number;
        midAngle: number;
        innerRadius: number;
        outerRadius: number;
        percent: number;
        index: number;
        count: number;
      }) => {
        if (count === 0 || count === null || count === undefined || isNaN(count)) {
          return <></>;
        }
        const radius = outerRadius + 20;
        const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
        const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
        const xLabel = cx + outerRadius * Math.cos(-midAngle * (Math.PI / 180));
        const yLabel = cy + outerRadius * Math.sin(-midAngle * (Math.PI / 180));
        // Utiliser la même couleur que le segment
        const lineColor = isAllValuesZero ? GREY : COLORS[index % COLORS.length];
      
        return (
          <line
            x1={xLabel}
            y1={yLabel}
            x2={x}
            y2={y}
            stroke={lineColor}
            strokeWidth={1}
          />
        );
      };
    const allValuesZero = (data: any) => {
        return data?.every((item: any) => item.count === 0 || item.count === null || item.count === undefined || isNaN(item.count));
      };
    const isAllValuesZero = allValuesZero(data);

  return (
    <div className="flex justify-center items-center">
       <PieChart width={200} height={200}>
          <Pie
            data={data}
            cx={100}
            label={renderLabel}
            labelLine={renderLabelLine}
            cy={100}
            innerRadius={40}
            outerRadius={60}
            fill="#8884d8"
            paddingAngle={2}
          dataKey="value"
      >
        {data?.map((_entry: any, index: number) => (
            <Cell
              key={`cell-${index}`}
              fill={
                isAllValuesZero
                  ? GREY
                  : COLORS[index % COLORS.length]
              }
            />
          ))}
      </Pie>
     </PieChart>
    </div>
  )
}

export default ProgressMissionMonitoring
